import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { GET_TABLE } from '../../../table.ui.store';

export function createHeaderTooltip(
  title: string,
  element: HTMLElement,
  trimTooltip: boolean = true,
): void {
  const table = GET_TABLE();

  const nameTooltip = new Tooltip({
    title,
    mobileTooltip: false,
    childTooltip: false,
    trimTooltip,
    element: element,
    trimElement: element,
  });

  nameTooltip.createTooltip();
}
